// extracted by mini-css-extract-plugin
export default {"container":"UploadInput_container__qQATb","file-name":"UploadInput_file-name__ULPbj","choosen-text":"UploadInput_choosen-text__14poT","info":"UploadInput_info__1e5j7"};